// project import
import Navigation from "./Navigation";
import SimpleBar from '@/components/third-party/SimpleBar';
import { useSelector } from 'react-redux';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <SimpleBar
      style={{
        flex: 1,
        height: "100%",
        overflowY: drawerOpen ? "auto" : "visible",
        overflowX: "visible",
        paddingTop: 0,
        marginTop: 0,
      }}
      className="flex flex-col pt-0 mt-0"
    >
      {/* Top Content */}
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
